export default __webpack_public_path__ + "static/media/BackgroundPwa.653d6997.png";